
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonButtons,
  IonBackButton,
} from '@ionic/vue';
import { defineComponent, ref, onMounted, onUnmounted } from 'vue';

import ThemeToggle from '../components/ThemeToggle.vue';

interface Reference {
  name: string;
  role: string;
  relationship?: string;
  linkedin: string;
  quote: string;
}

interface ReferencesData {
  references: Reference[];
}

export default defineComponent({
  name: 'References',
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonButtons,
    IonBackButton,
    ThemeToggle,
  },
  setup() {
    const loading = ref(true);
    const error = ref<string | null>(null);
    const references = ref<Reference[]>([]);

    let robotsMeta: HTMLMetaElement | null = null;
    let canonicalLink: HTMLLinkElement | null = null;

    const fetchData = async () => {
      try {
        loading.value = true;
        error.value = null;

        const response = await fetch(`${process.env.BASE_URL || '/'}data/references.json`.replace(/\/{2,}/g, '/'));
        if (!response.ok) {
          throw new Error(`Failed to load references data: ${response.status}`);
        }

        const data: ReferencesData = await response.json();
        references.value = data.references || [];
      } catch (err) {
        error.value = err instanceof Error ? err.message : 'Failed to load references data';
        console.error('References Data Error:', err);
      } finally {
        loading.value = false;
      }
    };

    onMounted(() => {
      // Keep this route out of search engines without affecting the rest of the site.
      robotsMeta = document.createElement('meta');
      robotsMeta.setAttribute('name', 'robots');
      robotsMeta.setAttribute('content', 'noindex,nofollow');
      document.head.appendChild(robotsMeta);

      // Canonical URL for this page is /recommendations (aliases redirect here).
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      canonicalLink.setAttribute('href', 'https://bryanchriswhite.com/recommendations');
      document.head.appendChild(canonicalLink);

      document.title = 'Recommendations — Bryan White';

      fetchData();
    });

    onUnmounted(() => {
      if (robotsMeta && robotsMeta.parentNode) {
        robotsMeta.parentNode.removeChild(robotsMeta);
        robotsMeta = null;
      }
      if (canonicalLink && canonicalLink.parentNode) {
        canonicalLink.parentNode.removeChild(canonicalLink);
        canonicalLink = null;
      }
    });

    return {
      loading,
      error,
      references,
    };
  },
});
